export default __webpack_public_path__ + "images/0x676f784d19c7f1ac6c6beaeaac78b02a73427852.png";